import PageHeaderRoot from './PageHeaderRoot';
import PageSummary from './PageSummary';

const PageHeaderCareers = () => {
  return (
    <PageHeaderRoot
      variant="careers"
      paper
      afterCol={<PageSummary variant="h4" />}
      GridProps={{ cx: { rowGap: 'md', pY: '5xl' } }}
    />
  );
};

export default PageHeaderCareers;
